module.exports = [
  '54b58957112602c9a0be7aa3' # inspiringboards
]



// WEBPACK FOOTER //
// ./app/scripts/data/copy-board-header-button-teams.coffee